import React, { useRef } from 'react';
import './CollegesSection.css';
import {
  FaCogs,           // Mechanical Engineering
  FaBrain,          // AI
  FaLaptopCode,     // CSE
  FaBroadcastTower, // ECE
  FaHardHat,        // Civil
  FaUniversity,     // Humanities & Basic Sciences
  FaDna,            // Biotechnology
  FaSeedling,       // Botany
  FaBriefcase,      // Business Management
  FaFlask,          // Chemistry
  FaStore,          // Commerce
  FaDesktop,        // Computer Science
  FaBalanceScale,   // Economics
  FaPenFancy,       // English
  FaAppleAlt,       // Food Science & Nutrition
  FaSquareRootAlt,  // Mathematics
  FaChartPie,       // Statistics
  FaAtom,           // Physics
  FaBookOpen,       // Telugu
  FaBug             // Zoology
} from 'react-icons/fa';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const CollegesSection = () => {
  const scrollContainerRef = useRef(null);

  const scroll = (direction) => {
    const container = scrollContainerRef.current;
    if (container) {
      const scrollAmount = 350;
      container.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth'
      });
    }
  };



const departments = [
  // College of Engineering
  {
    id: 1,
    name: 'Artificial Intelligence',
    college: 'College of Engineering',
    icon: <FaBrain />,
    route: '/academics/ai',
    color: '#0B3C5D'
  },
  {
    id: 2,
    name: 'Computer Science & Engineering',
    college: 'College of Engineering',
    icon: <FaLaptopCode />,
    route: '/academics/cse',
    color: '#0B3C5D'
  },
  {
    id: 3,
    name: 'Electronics & Communication Engineering',
    college: 'College of Engineering',
    icon: <FaBroadcastTower />,
    route: '/academics/electronics',
    color: '#0B3C5D'
  },
  {
    id: 4,
    name: 'Civil Engineering',
    college: 'College of Engineering',
    icon: <FaHardHat />,
    route: '/academics/civil',
    color: '#0B3C5D'
  },
  {
  id: 5,
  name: 'Mechanical Engineering',
  college: 'College of Engineering',
  icon: <FaCogs />,
  route: '/academics/mechanical',
  color: '#0B3C5D'
},
  {
    id: 6,
    name: 'Humanities & Basic Sciences',
    college: 'College of Engineering',
    icon: <FaUniversity />,
    route: '/academics/humanities-basic-sciences',
    color: '#0B3C5D'
  },

  // College of Science
  {
    id: 7,
    name: 'Biotechnology',
    college: 'University College',
    icon: <FaDna />,
    route: '/academics/biotechnology',
    color: '#0B3C5D'
  },
  {
    id: 8,
    name: 'Botany',
    college: 'University College',
    icon: <FaSeedling />,
    route: '/academics/botany',
    color: '#0B3C5D'
  },
  {
    id: 9,
    name: 'Business Management',
    college: 'University College',
    icon: <FaBriefcase />,
    route: '/academics/business-management',
    color: '#0B3C5D'
  },
  {
    id: 10,
    name: 'Chemistry',
    college: 'University College',
    icon: <FaFlask />,
    route: '/academics/chemistry',
    color: '#0B3C5D'
  },
  {
    id: 11,
    name: 'Commerce',
    college: 'University College',
    icon: <FaStore />,
    route: '/academics/commerce',
    color: '#0B3C5D'
  },
  {
    id: 12,
    name: 'Computer Science',
    college: 'University College',
    icon: <FaDesktop />,
    route: '/academics/computer-science',
    color: '#0B3C5D'
  },
  {
    id: 13,
    name: 'Economics',
    college: 'University College',
    icon: <FaBalanceScale />,
    route: '/academics/economics',
    color: '#0B3C5D'
  },
  {
    id: 14,
    name: 'English',
    college: 'University College',
    icon: <FaPenFancy />,
    route: '/academics/english',
    color: '#0B3C5D'
  },
  {
    id: 15,
    name: 'Food Science and Nutrition',
    college: 'University College',
    icon: <FaAppleAlt />,
    route: '/academics/food-science',
    color: '#0B3C5D'
  },
  {
    id: 16,
    name: 'Mathematics',
    college: 'University College',
    icon: <FaSquareRootAlt />,
    route: '/academics/mathematics',
    color: '#0B3C5D'
  },
  {
    id: 17,
    name: 'Statistics (OR & SQC)',
    college: 'University College',
    icon: <FaChartPie />,
    route: '/academics/statistics',
    color: '#0B3C5D'
  },
  {
    id: 18,
    name: 'Physics',
    college: 'University College',
    icon: <FaAtom />,
    route: '/academics/physics',
    color: '#0B3C5D'
  },
  {
    id: 19,
    name: 'Telugu',
    college: 'University College',
    icon: <FaBookOpen />,
    route: '/academics/telugu',
    color: '#0B3C5D'
  },
  {
    id: 20,
    name: 'Zoology',
    college: 'University College',
    icon: <FaBug />,
    route: '/academics/zoology',
    color: '#0B3C5D'
  }
];


  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        duration: 0.6
      }
    }
  };

  return (
    <section className="rukcs-colleges-section">
      <div className="rukcs-colleges-wrapper">
        <motion.div
          className="rukcs-colleges-header"
          initial={{ opacity: 0, y: -30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true, margin: "-100px" }}
        >
          <h2 className="rukcs-colleges-title">Departments</h2>
          {/* <p className="rukcs-colleges-subtitle">
            Explore our diverse academic departments across engineering and science disciplines
          </p> */}
        </motion.div>

        <motion.div
          className="rukcs-slider-container"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
        >
          <button 
            className="rukcs-slider-arrow rukcs-slider-arrow-left"
            onClick={() => scroll('left')}
            aria-label="Scroll left"
          >
            ‹
          </button>

          <div className="rukcs-slider-track" ref={scrollContainerRef}>
            {departments.map((dept) => (
              <Link
                key={dept.id}
                to={dept.route}
                className="rukcs-department-card-link"
              >
                <motion.div
                  className="rukcs-department-card"
                  whileHover={{ 
                    y: -10,
                    transition: { duration: 0.3 }
                  }}
                  style={{ '--dept-color': dept.color }}
                >
                  <div className="rukcs-department-icon">
                    {dept.icon}
                  </div>
                  <div className="rukcs-department-content">
                    <span className="rukcs-department-college">{dept.college}</span>
                    <h3 className="rukcs-department-name">{dept.name}</h3>
                  </div>
                  <div className="rukcs-department-overlay"></div>
                </motion.div>
              </Link>
            ))}
          </div>

          <button 
            className="rukcs-slider-arrow rukcs-slider-arrow-right"
            onClick={() => scroll('right')}
            aria-label="Scroll right"
          >
            ›
          </button>
        </motion.div>
      </div>
    </section>
  );
};

export default CollegesSection;